import React, { Component } from 'react';
import { connect } from "react-redux";
import { Field, reduxForm, formValueSelector } from "redux-form";
import {
    renderField,
    renderToggle,
    required,
    renderTextArea,
    json,
    number,
    positive_float, renderPassTextArea, renderPass
} from "../../../utils/formValidations.js";
import { withRouter } from "react-router-dom";
import { Alert } from "reactstrap";
import Proptypes from "prop-types";
import { getAutoScaleConfigs } from "../../../actions/actionAutoScale";
import { getLicenseStatus } from "../../../actions/actionFooter";
import { getZones } from "../../../actions/actionZones";
import { getServerPools } from "../../../actions/actionServerPool";
import { getVmProviderConfigs } from "../../../actions/actionVmProvider";
import { getDnsProviderConfigs } from "../../../actions/actionDnsProvider";
import { getLdap } from "../../../actions/actionLdap";
import { createServerPool } from "../../../actions/actionServerPool";


import SelectInput from "../../../components/SelectInput";
import {withTranslation} from "react-i18next";
import { Button, FormFooter, Groups, FormField } from "../../../components/Form"
import { hasAuth } from '../../../utils/axios.js';


class AutoScaleConfigFormTemplate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentAutoScaleConfig: {},
            collapseAdvanced: false,
            licensed: false,
            vmProviderModal: false,
            dnsProviderModal: false,
            serverPoolModal: false,
            disableMaxPerServer: false,
            pool: new URLSearchParams(this.props.location.search).get('pool') || null,
        };
        this.changeDnsProvider = this.changeDnsProvider.bind(this);
        this.changeServerPool = this.changeServerPool.bind(this);
        this.toggleServerPoolModal = this.toggleServerPoolModal.bind(this);
        this.cancelServerPoolModal = this.cancelServerPoolModal.bind(this);
        this.toggleVmProviderModal = this.toggleVmProviderModal.bind(this);
        this.cancelVmProviderModal = this.cancelVmProviderModal.bind(this);
        this.toggleDnsProviderModal = this.toggleDnsProviderModal.bind(this);
        this.cancelDnsProviderModal = this.cancelDnsProviderModal.bind(this);
        this.updateVmProvider = this.updateVmProvider.bind(this);
        this.updateDnsProvider = this.updateDnsProvider.bind(this);
        this.updateServerPool = this.updateServerPool.bind(this);
        this.initialize = this.initialize.bind(this);
        this.connection_type = this.connection_type.bind(this);
        this.reusableChange = this.reusableChange.bind(this);
        this.updateAgentInstalled = this.updateAgentInstalled.bind(this);
        this.changeConnectionCredentialType = this.changeConnectionCredentialType.bind(this);
        this.change_connection_credential_type = this.change_connection_credential_type.bind(this);

    }

    reusableChange(event) {
        if (this.props.autoscaleFormValues.connection_type === 'RDP' || this.props.autoscaleFormValues.connection_type === 'SSH') {
            if (event.target.checked === false) {
                this.setState({disableMaxPerServer: false});
                this.props.change('max_simultaneous_users', 1);
            } else {
                this.setState({disableMaxPerServer: false})
            }
        }
    }

    change_connection_credential_type(type) {
        const { t } = this.props;

        let optionsCredentialTypeRDP = [{label: t('servers.static'), value: "STATIC"},
            {label: t('servers.sso_create_user'), value: "SSO_CREATE_USER"},
            {label: t('servers.sso_username'), value: "SSO_USERNAME"},
            {label: t('servers.smartcard'), value: "SMARTCARD"}]
        let optionsCredentialTypeSSH = [{label: t('servers.static'), value: "STATIC"},
            {label: t('servers.sso_username'), value: "SSO_USERNAME"}]

        if (type === 'RDP') {
            this.setState({ connection_credential_type_options: optionsCredentialTypeRDP });
            this.props.change('connection_credential_type', 'STATIC');
        }
        if (type === 'SSH') {
            this.setState({ connection_credential_type_options: optionsCredentialTypeSSH });
            this.props.change('connection_credential_type', 'STATIC');
        }
    }

    connection_type(type) {
        if (type === 'KasmVNC' || type === 'VNC') {
            this.setState({ disableMaxPerServer: true });
            this.props.change('max_simultaneous_sessions_per_server', 1);
            this.props.change('connection_credential_type', null);
        }
        if (type === 'RDP' || type === 'SSH') {
            if (this.props.autoscaleFormValues.reusable === false || this.props.autoscaleFormValues.reusable === undefined || this.props.autoscaleFormValues.reusable === null) {
                this.setState({disableMaxPerServer: false});
                this.props.change('max_simultaneous_users', 1);
            } else {
                this.setState({disableMaxPerServer: false})
            }
        } else {
            this.props.autofill('max_simultaneous_users', undefined)
        }

        this.change_connection_credential_type(type)
    }

    changeServerPool(provider) {
        if (provider === 'new_pool') {
            this.setState({ serverPoolModal: true })
        }
    }

    toggleServerPoolModal() {
        this.setState({
            serverPoolModal: !this.state.serverPoolModal
        });
        if (this.state.serverPoolModal === true) {
            this.props.change('server_pool_id', null);
        }
    }
    cancelServerPoolModal() {
        this.setState({
            serverPoolModal: false
        });
        this.props.change('server_pool_id', null);
    }

    toggleVmProviderModal() {
        this.setState({
            vmProviderModal: !this.state.vmProviderModal
        });
        if (this.state.vmProviderModal === true) {
            this.props.change('vm_provider_config_id', null);
        }
    }
    cancelVmProviderModal() {
        this.setState({
            vmProviderModal: false
        });
        this.props.change('vm_provider_config_id', null);
    }

    changeDnsProvider(provider) {
        if (provider === 'new_provider') {
            this.setState({ dnsProviderModal: true })
        }
    }

    toggleDnsProviderModal() {
        this.setState({
            dnsProviderModal: !this.state.dnsProviderModal
        });
        if (this.state.dnsProviderModal === true) {
            this.props.change('dns_provider_config_id', null);
        }
    }
    cancelDnsProviderModal() {
        this.setState({
            dnsProviderModal: false
        });
        this.props.change('dns_provider_config_id', null);
    }



    cancelButton() {
        if (this.state.pool !== null) {
            this.props.history.push("/update_server_pool/" + this.state.pool + '?tab=autoscale');
        } else {
            this.props.history.push("/autoscale");
        }
    }


    initialize(config) {
        this.change_connection_credential_type(config.connection_type) // Set the options for connection credential types
        this.props.initialize({
            autoscale_config_name: config.autoscale_config_name,
            autoscale_type: config.autoscale_type,
            enabled: config.enabled,
            zone_id: config.zone_id,
            standby_cores: config.standby_cores,
            standby_memory_gb: config.standby_memory_mb/1024,
            standby_gpus: config.standby_gpus,
            downscale_backoff: config.downscale_backoff,
            register_dns: config.register_dns,
            base_domain_name: config.base_domain_name,
            agent_cores_override: config.agent_cores_override,
            agent_memory_override_gb: config.agent_memory_override_gb,
            agent_gpus_override: config.agent_gpus_override,
            connection_type: config.connection_type,
            connection_credential_type: config.connection_credential_type,
            connection_info: config.connection_info ? JSON.stringify(config.connection_info, null, 2) : null,
            connection_port: config.connection_port,
            connection_username: config.connection_username,
            connection_password: config.connection_password,
            connection_private_key: config.connection_private_key,
            connection_passphrase: config.connection_passphrase,
            use_user_private_key: config.use_user_private_key,
            reusable: config.reusable,
            hooks: config.hooks ? JSON.stringify(config.hooks, null, 2) : null,
            minimum_pool_standby_sessions: config.minimum_pool_standby_sessions,
            max_simultaneous_sessions_per_server: config.max_simultaneous_sessions_per_server,
            max_simultaneous_users: config.max_simultaneous_users,
            vm_provider_config_id: config.vm_provider_config_id,
            dns_provider_config_id: config.dns_provider_config_id,
            server_pool_id: config.server_pool_id,
            ad_create_machine_record: config.ad_create_machine_record,
            ad_recursive_machine_record_cleanup: config.ad_recursive_machine_record_cleanup,
            ad_computer_container_dn: config.ad_computer_container_dn,
            agent_installed: config.agent_installed,
            require_checkin: config.agent_installed === true ? true : config.require_checkin,
            aggressive_scaling: config.aggressive_scaling,
            ldap_id: config.ldap_id,
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.autoscale_configs && nextProps.autoscale_configs.length > 0 && this.props.autoscale_configs !== nextProps.autoscale_configs && this.props.getAutoScaleLoading && this.props.fromUpdate) {
            let currentAutoScaleConfig = nextProps.autoscale_configs.find(autoscale => autoscale.autoscale_config_id === this.props.autoscaleConfigId);
            this.setState({ currentAutoScaleConfig: currentAutoScaleConfig });
            this.change_connection_credential_type(currentAutoScaleConfig.connection_type)
            this.initialize(currentAutoScaleConfig)
            if (currentAutoScaleConfig.connection_type === 'KasmVNC' || currentAutoScaleConfig.connection_type === 'VNC') {
                this.setState({ disableMaxPerServer: true });
            }
            if (currentAutoScaleConfig.connection_type === 'RDP' || currentAutoScaleConfig.connection_type === 'SSH') {
                if (currentAutoScaleConfig.reusable === false || currentAutoScaleConfig.reusable === undefined || currentAutoScaleConfig.reusable === null) {
                    this.setState({ disableMaxPerServer: false });
                }
                else {
                    this.setState({ disableMaxPerServer: false });
                }
            }

        }
        if (nextProps.license_info && nextProps.license_info !== this.props.license_info) {
            this.setState({ licensed: nextProps.license_info.status.features.indexOf('auto_scaling') >= 0 });
        }
    }

    async componentDidMount() {
        this.props.getZones()
        this.props.getVmProviderConfigs()
        this.props.getDnsProviderConfigs()
        this.props.getLdap()
        const { license_info } = this.props;
        if (license_info && license_info.status && license_info.status.features && license_info.status.features.indexOf('auto_scaling') >= 0) {
            this.setState({ licensed: true });
        }
        try {
            await this.props.getServerPools()
            if (this.props.server_pools.length > 0 && this.state.pool !== null) {
                const pool_details = this.props.server_pools.find(pool => pool.server_pool_id === this.state.pool)
                this.props.change('server_pool_id', this.state.pool);
                this.props.change('autoscale_type', pool_details.server_pool_type);
                this.props.onTypeChange(pool_details.server_pool_type)
            }
        } catch (e) {

        }
        if (this.props.autoscale_config) {
            this.initialize(this.props.autoscale_config)
        }
    }

    updateVmProvider(data) {
        this.props.getVmProviderConfigs()
        this.props.change('vm_provider_config_id', data.vm_provider_config_id);
        this.setState({
            vmProviderModal: false
        });
    }

    updateDnsProvider(data) {
        this.props.getDnsProviderConfigs()
        this.props.change('dns_provider_config_id', data.dns_provider_config_id);
        this.setState({
            dnsProviderModal: false
        });
    }
    updateServerPool(data) {
        this.props.getServerPools()
        this.props.change('server_pool_id', data.server_pool_id);
        this.setState({
            serverPoolModal: false
        });
    }
    updateAgentInstalled(data) {
        this.props.change('agent_installed', data.target.checked);
        if (data.target.checked) {
            this.props.change('require_checkin', true);
        }
    }

    changeConnectionCredentialType(type) {
        if (type === 'STATIC') {
            this.props.change('max_simultaneous_users', 1);
        }
        if (type !== 'STATIC') {
            this.props.autofill('connection_username', undefined)
            this.props.autofill('connection_password', undefined)
        }
        if (type !== 'SSO_USERNAME') {
            this.props.autofill('connection_sso_username_domain', undefined)
        }
    }

    render() {
        const { handleSubmit, autoscaleFormValues, zones, server_pools, vm_provider_configs, dns_provider_configs,
            ldap_configs, t } = this.props;
        if (!this.state.licensed) {
            let license_url = `${__LICENSE_INFO_URL__}`;
            return (
                <Alert color="none" isOpen={true}>
                    <h4>{t("autoscale.Unavailable")}</h4>
                    {t("autoscale.This feature must be licensed")}
                    <hr />
                    <a href={license_url}>{t("autoscale.More Information")}</a><br />
                </Alert>
            )
        }

        let optionsZones = [];
        zones.map(opt => {
            optionsZones.push({ label: opt.zone_name, value: opt.zone_id, zone_name: opt.zone_name });
        });
        optionsZones.sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase()) ? 1 : -1);

        let optionsAutoScaleTypes = [
            { value: 'Docker Agent', label: t("autoscale.Docker Agent") },
            { value: 'Server Pool', label: t("autoscale.Server") }
        ]

        let optionServerPools = [];
        server_pools.map(opt => {
            optionServerPools.push({ label: opt.server_pool_name, value: opt.server_pool_id });
        });
        optionServerPools.sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase()) ? 1 : -1);

        let optionDnsProviders = [];
        dns_provider_configs.map(opt => {
            optionDnsProviders.push({ label: opt.dns_provider_config_name, value: opt.dns_provider_config_id });
        });
        optionDnsProviders.sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase()) ? 1 : -1);

        let optionsConnectionTypes = [
            { value: 'KasmVNC', label: 'KasmVNC' },
            { value: 'RDP', label: 'RDP' },
            { label: "VNC", value: "VNC" },
            { label: "SSH", value: "SSH" }
        ]


        let optionsLdapConfigs = [];
        ldap_configs.map(opt => {
            optionsLdapConfigs.push({ label: opt.name, value: opt.ldap_id });
        });
        optionsLdapConfigs.sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase()) ? 1 : -1);

        let display_max_users = false
        let max_users_disabled = false
        if (autoscaleFormValues) {
            if (autoscaleFormValues.connection_type === 'RDP' || autoscaleFormValues.connection_type === 'SSH') {
                display_max_users = true
                if (autoscaleFormValues.connection_credential_type === 'STATIC' || !autoscaleFormValues.reusable) {
                    max_users_disabled = true
                }
            }
        }

        return (
            <Groups noPadding section="autoscale" onSubmit={handleSubmit}>
                <FormField label="Enabled">
                    <Field type="checkbox"
                        name="enabled"
                        id="enabled"
                        component={renderToggle}
                    />
                </FormField>

                <FormField label="Name">
                    <Field type="text"
                        name="autoscale_config_name"
                        id="autoscale_config_name"
                        component={renderField}
                        validate={required} required
                    />
                </FormField>
                <FormField label="AutoScale Type">
                    <Field name="autoscale_type"
                        selectedValue={autoscaleFormValues && autoscaleFormValues.autoscale_type ? autoscaleFormValues.autoscale_type : ""}
                        onOptionChange={this.props.onTypeChange}
                        options={optionsAutoScaleTypes}
                        isUpdateForm={this.props.fromUpdate}
                        help="kb-25-1"
                        validate={required} required
                        disabled={this.state.pool !== null || this.props.fromUpdate}
                        component={SelectInput} />
                </FormField>
                {hasAuth('pools') && <FormField label="Pool">
                    <Field name="server_pool_id"
                        selectedValue={autoscaleFormValues && autoscaleFormValues.server_pool_id}
                        options={optionServerPools}
                        isUpdateForm={this.props.fromUpdate}
                        onOptionChange={this.changeServerPool}
                        help="kb-25-2"
                        validate={required} required
                        disabled={this.state.pool !== null || this.props.fromUpdate}
                        component={SelectInput} />
                </FormField>}
                <Field type="checkbox"
                        name="aggressive_scaling"
                        help="kb-25-3"
                        component={renderToggle}
                />
                {hasAuth('zones') && <FormField label="Deployment Zone">
                    <Field name="zone_id"
                        selectedValue={autoscaleFormValues && autoscaleFormValues.zone_id ? autoscaleFormValues.zone_id : ""}
                        options={optionsZones}
                        help="kb-25-4"
                        isUpdateForm={this.props.fromUpdate}
                        validate={required} required
                        component={SelectInput} />
                </FormField>}
                {autoscaleFormValues && (
                    <FormField label="Downscale Backoff (Seconds)">
                        <Field
                            type="number"
                            name="downscale_backoff"
                            help="kb-25-27"
                            id="downscale_backoff"
                            component={renderField}
                            validate={number} required
                        />
                    </FormField>
                )}
                {autoscaleFormValues && autoscaleFormValues.autoscale_type === "Server Pool" && (
                    <React.Fragment>
                        <Field type="checkbox"
                                name="require_checkin"
                                help="kb-25-5"
                                component={renderToggle}
                                disabled={autoscaleFormValues && autoscaleFormValues.agent_installed === true}
                        />
                        <Field type="checkbox"
                               name="agent_installed"
                               help="kb-25-6"
                               component={renderToggle}
                               onChange={this.updateAgentInstalled}
                        />
                        <FormField label="Connection Type">
                            <Field name="connection_type"
                                selectedValue={autoscaleFormValues && autoscaleFormValues.connection_type ? autoscaleFormValues.connection_type : ""}
                                options={optionsConnectionTypes}
                                help="kb-25-7"
                                validate={required} required
                                onOptionChange={this.connection_type}
                                isUpdateForm={this.props.fromUpdate}
                                component={SelectInput}
                            />
                        </FormField>
                        <FormField label="Connection Port">
                            <Field type="number"
                                name="connection_port"
                                help="kb-25-8"
                                id="connection_port"
                                component={renderField}
                                validate={number} required
                            />
                        </FormField>
                        {autoscaleFormValues && (autoscaleFormValues.connection_type === 'RDP' || autoscaleFormValues.connection_type === 'SSH') &&
                            <Field name="connection_credential_type"
                                   selectedValue={autoscaleFormValues && autoscaleFormValues.connection_credential_type ? autoscaleFormValues.connection_credential_type : ""}
                                   options={this.state.connection_credential_type_options}
                                   validate={required} required
                                   help="kb-25-9"
                                   onOptionChange={this.changeConnectionCredentialType}
                                   isUpdateForm={this.props.fromUpdate}
                                   component={SelectInput}
                            />
                        }
                        {autoscaleFormValues && autoscaleFormValues.connection_type === 'RDP' && autoscaleFormValues.connection_credential_type === 'SSO_USERNAME' &&
                            <FormField label="Connection SSO Username Domain">
                                <Field type="text"
                                       name="connection_sso_username_domain"
                                       help="kb-25-10"
                                       id="connection_sso_username_domain"
                                       component={renderField}
                                />
                            </FormField>
                        }
                        {autoscaleFormValues && (autoscaleFormValues.connection_credential_type === 'STATIC' || (autoscaleFormValues.connection_type !== 'RDP' && autoscaleFormValues.connection_type !== 'SSH')) &&
                            <FormField label="Connection Username">
                                <Field type="text"
                                    name="connection_username"
                                    help="kb-25-11"
                                    id="connection_username"
                                    component={renderField}
                                    validate={this.props.autoscaleFormValues && this.props.autoscaleFormValues.connection_type === 'KasmVNC' ? required : null} required={this.props.autoscaleFormValues && this.props.autoscaleFormValues.connection_type === 'KasmVNC'}
                                />
                            </FormField>
                        }
                        {autoscaleFormValues && (autoscaleFormValues.connection_credential_type === 'STATIC' || (autoscaleFormValues.connection_type !== 'RDP' && autoscaleFormValues.connection_type !== 'SSH')) &&
                            <FormField label="Connection Password">
                                <Field type="connection_password"
                                    name="connection_password"
                                    help="kb-25-12"
                                    id="connection_password"
                                    component={renderPass}
                                    validate={this.props.autoscaleFormValues && this.props.autoscaleFormValues.connection_type === 'KasmVNC' ? required : null} required={this.props.autoscaleFormValues && this.props.autoscaleFormValues.connection_type === 'KasmVNC'}
                                />
                            </FormField>
                        }
                        {this.props.autoscaleFormValues && this.props.autoscaleFormValues.connection_type === 'SSH' && (
                            <FormField label="Use User SSH Key">
                                <Field type="checkbox"
                                    name="use_user_private_key"
                                    help="kb-25-13"
                                    id="use_user_private_key"
                                    checked={autoscaleFormValues && autoscaleFormValues.use_user_private_key}
                                    component={renderToggle}
                                />
                            </FormField>
                        )}
                        {this.props.autoscaleFormValues && this.props.autoscaleFormValues.connection_type === 'SSH' && !this.props.autoscaleFormValues.use_user_private_key && (
                            <FormField label="connection_formats">
                                <Field type="textarea"
                                    name="connection_private_key"
                                    help="kb-25-14"
                                    id="connection_private_key"
                                    component={renderPassTextArea}
                                    disabled={this.props.autoscaleFormValues.use_user_private_key}
                                    placeholder="-----BEGIN RSA PRIVATE KEY-----&#10;...&#10;-----END RSA PRIVATE KEY-----"
                                />
                            </FormField>
                        )}
                        {this.props.autoscaleFormValues && this.props.autoscaleFormValues.connection_type === 'SSH' && !this.props.autoscaleFormValues.use_user_private_key && (
                            <FormField label="Connection Private Key Passphrase">
                                <Field type="connection_passphrase"
                                    name="connection_passphrase"
                                    help="kb-25-15"
                                    id="connection_passphrase"
                                    component={renderPass}
                                    disabled={this.props.autoscaleFormValues.use_user_private_key}
                                />
                            </FormField>
                        )}
                        <FormField label="Connection Info (JSON)">
                            <Field type="textarea"
                                name="connection_info"
                                help="kb-25-16"
                                id="connection_info"
                                component={renderTextArea}
                                validate={json}
                            />
                        </FormField>
                        <FormField label="Create Active Directory Computer Record">
                            <Field type="checkbox"
                                name="ad_create_machine_record"
                                help="kb-25-17"
                                id="ad_create_machine_record"
                                checked={autoscaleFormValues && autoscaleFormValues.ad_create_machine_record}
                                component={renderToggle}
                            />
                        </FormField>
                        {autoscaleFormValues && autoscaleFormValues.ad_create_machine_record ?
                            <React.Fragment>
                                <FormField style={{ 'padding-left': '20px' }} label="LDAP Config">
                                    <Field name="ldap_id"
                                        selectedValue={autoscaleFormValues.ldap_id}
                                        options={optionsLdapConfigs}
                                        help="kb-25-18"
                                        isUpdateForm={this.props.fromUpdate}
                                        validate={required} required
                                        component={SelectInput} />
                                </FormField>
                                <FormField style={{ 'padding-left': '20px' }} label="Active Directory Computer OU DN">
                                    <Field type="text"
                                        name="ad_computer_container_dn"
                                        id="ad_computer_container_dn"
                                        help="kb-25-19"
                                        component={renderField}
                                        validate={required} required
                                        placeholder="OU=KasmComputers,DC=example,DC=com"
                                    />
                                </FormField>
                                <FormField label="Recursively Cleanup Active Directory Computer Record">
                                    <Field name="ad_recursive_machine_record_cleanup"
                                        id="ad_recursive_machine_record_cleanup"
                                        help="kb-25-20"
                                        checked={autoscaleFormValues && autoscaleFormValues.ad_recursive_machine_record_cleanup}
                                        type="checkbox"
                                        component={renderToggle}
                                    />
                                </FormField>

                            </React.Fragment>
                            :
                            ""
                        }
                        <FormField label="Reusable">
                            <Field name="reusable"
                                id="reusable"
                                checked={autoscaleFormValues && autoscaleFormValues.reusable}
                                type="checkbox"
                                help="kb-25-21"
                                component={renderToggle}
                                onChange={this.reusableChange}
                            />
                        </FormField>

                        <FormField label="Minimum Available Sessions">
                            <Field type="number"
                                name="minimum_pool_standby_sessions"
                                help="kb-25-22"
                                id="minimum_pool_standby_sessions"
                                component={renderField}
                                validate={number} required
                                placeholder="0"
                            />
                        </FormField>
                        <FormField label="Max Simultaneous Sessions Per Server">
                            <Field type="number"
                                name="max_simultaneous_sessions_per_server"
                                help="kb-25-23"
                                id="max_simultaneous_sessions_per_server"
                                component={renderField}
                                disabled={this.state.disableMaxPerServer}
                                validate={number} required
                                placeholder="1"
                            />
                        </FormField>
                        {autoscaleFormValues && display_max_users &&
                        <FormField label="Max Simultaneous Users Per Server">
                            <Field type="number"
                                name="max_simultaneous_users"
                                id="max_simultaneous_users"
                                disabled={max_users_disabled}
                                component={renderField}
                                validate={number} required
                                placeholder="1"
                                help="kb-25-35"
                            />
                        </FormField>}
                    </React.Fragment>
                )}
                {autoscaleFormValues && autoscaleFormValues.autoscale_type === "Docker Agent" && (
                    <React.Fragment>

                        <FormField label="Standby Cores">
                            <Field
                                type="number"
                                name="standby_cores"
                                help="kb-25-24"
                                id="standby_cores"
                                component={renderField}
                                validate={number} required
                            />
                        </FormField>
                        <FormField label="Standby GPUs">
                            <Field
                                type="number"
                                name="standby_gpus"
                                help="kb-25-25"
                                id="standby_gpus"
                                component={renderField}
                                validate={number} required
                            />
                        </FormField>
                        <FormField label="standby-memory-gb">
                            <Field
                                type="number"
                                name="standby_memory_gb"
                                help="kb-25-36"
                                id="standby_memory_mb"
                                component={renderField}
                                validate={positive_float} required
                            />
                        </FormField>
                        <FormField label="Agent Cores Override">
                            <Field type="number"
                                name="agent_cores_override"
                                help="kb-25-28"
                                id="agent_cores_override"
                                component={renderField}
                                validate={number} required
                            />
                        </FormField>
                        <FormField label="Agent GPUs Override">
                            <Field type="number"
                                name="agent_gpus_override"
                                help="kb-25-29"
                                id="agent_gpus_override"
                                component={renderField}
                                validate={number} required
                            />
                        </FormField>
                        <FormField label="Agent Memory Override (GB)">
                            <Field type="number"
                                name="agent_memory_override_gb"
                                help="kb-25-30"
                                id="agent_memory_override_gb"
                                component={renderField}
                                validate={positive_float} required
                            />
                        </FormField>

                        <FormField label="Register DNS">
                            <Field type="checkbox"
                                name="register_dns"
                                help="kb-25-33"
                                id="register_dns"
                                onChange={(value) => this.props.onRegisterDns(value.target.checked)}
                                checked={autoscaleFormValues && autoscaleFormValues.register_dns}
                                component={renderToggle}
                            />
                        </FormField>
                        {autoscaleFormValues && autoscaleFormValues.register_dns ?
                            <React.Fragment>
                                <FormField label="Base Domain Name">
                                    <Field type="text"
                                        name="base_domain_name"
                                        help="kb-25-34"
                                        id="base_domain_name"
                                        component={renderField}
                                        validate={required} required
                                    />
                                </FormField>

                            </React.Fragment>
                            : ""}

                    </React.Fragment>
                )}

                <FormFooter
                    cancel={() => this.cancelButton()}
                    saveButton={hasAuth('vm_providers') && <Button id="save-autoscale" icon="save" type="submit" section="buttons" name="Next" />}
                />
            </Groups>
        );
    }
}

AutoScaleConfigFormTemplate.proptypes = {
    createAutoScaleConfig: Proptypes.func,
    updateAutoScaleConfig: Proptypes.func,
    fromUpdate: Proptypes.bool,
    zones: Proptypes.array,
    server_pools: Proptypes.array,
    vm_provider_configs: Proptypes.array,
    dns_provider_configs: Proptypes.array,
    ldap_configs: Proptypes.array,
    createServerPool: Proptypes.func.isRequired,
};

let AutoScaleConfigFormWithRouter = withRouter(AutoScaleConfigFormTemplate);


const selector = formValueSelector('AutoScaleConfigForm');

let AutoScaleConfigForm = connect(state => {

    const has_categorization_enabled = selector(state, 'enable_categorization');

    return {
        has_categorization_enabled,
        updateAutoScaleError: state.autoscale.updateAutoScaleError,
        updateAutoScaleLoading: state.autoscale.updateAutoScaleLoading,
        updatedAutoScale: state.autoscale.updatedAutoScale,
        autoscale_configs: state.autoscale.autoscale_configs,
        getAutoScaleLoading: state.autoscale.getAutoScaleLoading || false,
        license_info: state.footer && state.footer.license_info ? state.footer.license_info : null,
        autoscaleFormValues: state.form && state.form.AutoScaleConfigForm && state.form.AutoScaleConfigForm.values ? state.form.AutoScaleConfigForm.values : null,
        zones: state.zones.zones || [],
        server_pools: state.server_pools.server_pools || [],
        vm_provider_configs: state.vm_provider.vm_provider_configs || [],
        dns_provider_configs: state.dns_provider.dns_provider_configs || [],
        ldap_configs: state.ldap_configs.ldap_configs || [],
        connection_credential_type_options: [],
    }
},

    dispatch =>
    ({
        getAutoScaleConfigs: () => dispatch(getAutoScaleConfigs()),
        getLicenseStatus: () => dispatch(getLicenseStatus()),
        getVmProviderConfigs: () => dispatch(getVmProviderConfigs()),
        getDnsProviderConfigs: () => dispatch(getDnsProviderConfigs()),
        getZones: () => dispatch(getZones()),
        getServerPools: () => dispatch(getServerPools()),
        getLdap: () => dispatch(getLdap()),
        createServerPool: (data) => dispatch(createServerPool(data)),

    }))(AutoScaleConfigFormWithRouter);
    const AutoScaleConfigFormTranslated = withTranslation('common')(AutoScaleConfigForm)
export default reduxForm({
    form: "AutoScaleConfigForm",
    initialValues: { enabled: true },
})(AutoScaleConfigFormTranslated);
